// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner_banner__a373G","big":"Banner_big__3vg9g","small":"Banner_small__1z6Ov","square":"Banner_square__rF_1A"};